import React, { useState, useEffect } from "react";
import { Switch, Route, useHistory, Router, Link, useParams } from "react-router-dom";
import AppListContent from "./AppListContent";
import AppsReviewContent from "./AppsReviewContent";
import { Badge, Button } from '@material-ui/core';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import DevDynContent from "./DevDynContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import axios from 'axios';
import translate from '../../other/translate.json';
import config from '../../other/config';
const { serverAPI } = config;

export default function AppListRouter(props) {
	let { IsRu, setIsRu, handleExpandClick, showPagination  , userCollection, saveCollection} = props

	const language = localStorage.getItem('language') || 'Ru'
	let { bank } = useParams();
	let history = useHistory()
	const classes = useStyles();
	const [dynamicsArrCount, setDynamicsArrCount] = useState(0);
	const [bankinfo, setBankinfo] = useState([]);
	const [statusBtn, setStatusBtn] = useState(0);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [savedFilters, _savedFilters] = useState(null);
	const [loading, _loading] = useState(true);



	const StyledButton = withStyles({
		root: {
			background: 'transparent',
			borderRadius: 0,
			border: 0,
			borderBottom: '1px solid #93919B',
			height: 48,
			padding: '0 8px',
			color: '#8987A2',
			fontFamily: 'Cera CY',
			fontStyle: 'normal',
			fontWeight: 'normal',
			fontSize: '16px',
			lineHeight: '24px',
		},

		label: {
			textTransform: 'capitalize',
		},
	})(Button);

	const StyledButtonSelected = withStyles({
		root: {
			background: 'transparent',
			borderRadius: 0,
			border: 0,
			borderBottom: '3px solid #24262A',
			height: 48,
			padding: '0 8px',
			color: '#24262A',
			fontFamily: 'Cera CY',
			fontStyle: 'normal',
			fontWeight: 'normal',
			fontSize: '16px',
			lineHeight: '24px',
		},

		label: {
			textTransform: 'capitalize',
		},
	})(Button);

	useEffect(() => {


		let didCancel = false;
		async function fetchData() {
			let {href} = window.location;
			if (href.indexOf('/applications/') > -1 && href.indexOf('/applist') > -1 && href.indexOf('filters=') > -1 ) {
				const savedFilters = await axios.get(`${serverAPI}/get_saved_filters?filters=${href.split('filters=')[1]}`)
				_savedFilters(savedFilters.data.filters)
			}
			_loading(false);
		}
		if (!didCancel) {
			fetchData();
		}
		return () => {
			didCancel = true;
		};
	}, []);


	useEffect(() => {
		if (/overview/gmi.test(history.location.pathname)) { setStatusBtn(0) }
		if (/applist/gmi.test(history.location.pathname)) { setStatusBtn(1) }
		if (/dynamics/gmi.test(history.location.pathname)) { setStatusBtn(2) }

		// if (/cloud/gmi.test(history.location.pathname)) { 	setSelectedIndex(4) }
		// if (/applications/gmi.test(history.location.pathname)) { setSelectedIndex(3) }
		// if (/products/gmi.test(history.location.pathname)) { setSelectedIndex(2) }
		// if (/solutions/gmi.test(history.location.pathname)) { setSelectedIndex(1) }


	}, [history.location.pathname])
	useEffect(() => {
		//handleExpandClick(3)  Tarasenko логика перенесена на LeftBar
		
		if (bank !== undefined) {
			let didCancel = false;
			async function fetchData() {
				const _bankinfo = await axios.get(`${serverAPI}/bankinfo/${bank}/3/${language}`)
				if (!didCancel) {
					if (_bankinfo && _bankinfo.data) {
						if (_bankinfo.data[0].isShowDynamics === 1) {
							setDynamicsArrCount(1)
						} else {
							setDynamicsArrCount(0)
						}
						setBankinfo(_bankinfo.data[0]);
						let cur = _bankinfo.data[0].Currency;						
						if (/*userCollection.inCu === '1' && ![0,2].includes(cur) || userCollection.inCu !== '1' && ![1,2].includes(cur)  */ cur !== 2){
							//console.log('setCu', userCollection._CatalogCu)
							userCollection._CatalogCu(cur === 1 ? '0' : '1')
						}
							
					}
				}
			}

			fetchData();
			return () => {
				didCancel = true;
			}
		}
	}, [bank]);

	const eventBtnOverview = () => {
		// props.setListNumProps(0)
		setStatusBtn(0)
	}

	function swRoute(path) {
		switch (path.substr(-8)) {
			case 'overview': { break; }
			case '/applist': { break; }
			case '/apptags': { break; }
			case 'dynamics': { break; }
			default: props.setErr(true);
		}
	}

	

	return (
		<Grid
			container
		>					{
				window.location.pathname.indexOf("/applications/apptags") > -1
					?
					null
					:
					<Grid
						item
						container
						direction="row"
						justify="space-between"
						alignItems="center"
						className={classes.HeaderCntr}
					>
						<Grid item>
							<Typography className={classes.sectionTitle} variant="h5">
								{
									/\/zk\/applist\?filt=false&direction=208/gmi.test(window.location.href) ? 'ПО для работы с криптографическими ключами' :
										/\/zk\/applist\?filt=false&direction=88/gmi.test(window.location.href) ? 'ЦФТ-Банкомат' :
											/\/zk\/applist\?filt=false&direction=89/gmi.test(window.location.href) ? 'ЦФТ-Приложение для терминала на единой платформе' :
												/\/zk\/applist\?filt=false&direction=208/gmi.test(window.location.href) ? 'ПО для работы с криптографическими ключами' :
													bankinfo
														?
														bankinfo.isArchive === 1
															?
															<StyledBadge badgeContent={translate.Words[`Archive${language}`]} color="error">
																{bankinfo.Title}
															</StyledBadge>
															:
															bankinfo.Title
														:
														''
								}
							</Typography>
						</Grid>

						<Grid item></Grid>
						{
							window.location.pathname.indexOf("/applications/apptags") > -1
								?
								null
								:
								<Grid item>
									<ButtonGroup size="small" aria-label="small outlined button group">
										{
											props && props.catalog // && props.catalog.count && props.catalog.count > 0 || dynamicsArrCount > 0
												?
												<Link to={`/applications/${bank}/overview`} className={classes.elemBtnGroup} onClick={() => eventBtnOverview()} style={{ textDecoration: 'none' }}>
													{
														statusBtn === 0
														?
														<StyledButtonSelected>{translate.Words[`Overview${language}`]}</StyledButtonSelected>
														:
														<StyledButton>{translate.Words[`Overview${language}`]}</StyledButton>
													}
												</Link>
												:
												null
										}

										{
											props && props.catalog // && props.catalog.count && props.catalog.count > 0
											
												?
												<Link to={`/applications/${bank}/applist`} className={classes.elemBtnGroup} onClick={() => setStatusBtn(1)} style={{ textDecoration: 'none' }}>
													{ 
														statusBtn === 1 
														?
														<StyledButtonSelected>{translate.Words[`Applications_${language}`]}</StyledButtonSelected>
														:
														<StyledButton>{translate.Words[`Applications_${language}`]}</StyledButton>
													}	
												</Link>
												:
												null										
										}

										{
											dynamicsArrCount > 0
												?
												
													<Link to={`/applications/${bank}/dynamics`} className={classes.elemBtnGroup} onClick={() => setStatusBtn(2)} style={{ textDecoration: 'none' }}>
														{
															statusBtn === 2
															?
															<StyledButtonSelected>{translate.Words[`Dynamics_${language}`]}</StyledButtonSelected>
															:
															<StyledButton>{translate.Words[`Dynamics_${language}`]}</StyledButton>
														}
													</Link>
													
													:
													null
										}
									</ButtonGroup>
								</Grid>
						}
					</Grid>
			}

			<Switch>
				<Router history={history}>
					<Route exact path='/applications/:bank/overview'>
						<AppsReviewContent
							setErr={props.setErr}
							selectedIndex={selectedIndex}
							IsRu={IsRu}
							language={language}
							userCollection = {userCollection}
							saveCollection = {saveCollection}
						/>
					</Route>

					{
						props.apptags
							?
							<React.Fragment>
								<Route exact path='/applications/apptags'>
									<AppListContent
										selectedIndex={selectedIndex}
										// setListNumProps={props.setListNumProps}
										// listNum={props.listNum}
										info={bankinfo}
										IsRu={language === 'Ru'}
										setIsRu={setIsRu}
										bank={bank}
										catalog={props.catalog}
										usname={props.usname}
										handleCloseCookieSnackbar={props.handleCloseCookieSnackbar}
										kloUser = {props.kloUser}
										getKloStatuses = {props.getKloStatuses}
										_kloUser = {props._kloUser}
										userCollection = {userCollection}
										saveCollection = {saveCollection}
										savedFilters = {savedFilters}
									/>
								</Route>
							</React.Fragment>
							:
							props.catalog.ID_Category !== undefined && !loading
								?
								<Route exact path='/applications/:bank/applist'>
									<AppListContent
										selectedIndex={selectedIndex}
										// setListNumProps={props.setListNumProps}
										// listNum={props.listNum}
										info={bankinfo}
										IsRu={language === 'Ru'}
										setIsRu={setIsRu}
										bank={bank}
										catalog={props.catalog}
										usname={props.usname}
										handleCloseCookieSnackbar={props.handleCloseCookieSnackbar}
										showPagination={showPagination}
										kloUser = {props.kloUser}
										getKloStatuses = {props.getKloStatuses}
										_kloUser = {props._kloUser}
										searchPhrases={props.searchPhrases}
										userCollection = {userCollection}
										saveCollection = {saveCollection}
										savedFilters = {savedFilters}
									/>
								</Route>
								:
								bankinfo.ID_Category !== undefined && !loading
									?
									<Route exact path='/applications/:bank/applist'>
										<AppListContent
											selectedIndex={selectedIndex}
											// setListNumProps={props.setListNumProps}
											// listNum={props.listNum}
											info={bankinfo}
											IsRu={language === 'Ru'}
											setIsRu={setIsRu}
											bank={bank}
											catalog={props.catalog}
											usname={props.usname}
											handleCloseCookieSnackbar={props.handleCloseCookieSnackbar}
											kloUser={props.kloUser}
											_kloUser={props._kloUser}
											searchPhrases={props.searchPhrases}
											getKloStatuses={props.getKloStatuses}
											userCollection={userCollection}
											saveCollection={saveCollection}
											savedFilters={savedFilters}
										/>
									</Route>
									:
									null
					}

					<Route exact path='/applications/:bank/dynamics'>
						<DevDynContent
							IsRu={IsRu}
							selectedIndex={selectedIndex}
							// setListNumProps={props.setListNumProps}
							// listNum={props.listNum}
							bank={bank}
							key={bank}
							language={language}
						/>
					</Route>

					{
						bankinfo == undefined
							?
							// console.log('bankinfo', bankinfo, 'bank', bank)
							props.setErr(true)
							:
							swRoute(window.location.pathname)
						// null
					}
				</Router>
			</Switch>
		</Grid>
	)
}

const StyledBadge = withStyles((theme) => ({
	badge: {
		right: -64,
		// top: -10,
		// border: `2px solid ${theme.palette.background.paper}`,
		borderRadius: 39,
		padding: '0 8px',
		backgroundColor: '#BCBBD0',
		color: '#FFF',
		fontSize: 13,
		lineHeight: "15px",
		transform: 'none',
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		height: 24,
		textAlign: 'center'
	},
}))(Badge);


const useStyles = makeStyles(theme => ({
	sectionTitle: {
		fontSize: 40,
		fontWeight: 500,
	},

	HeaderCntr: {
		minHeight: 60
	},

	elemBtnGroup: {
		minWidth: 'unset'
	}
}));